// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3E2kY","dragIcon":"SortableItem_dragIcon__5YhGi","disabled":"SortableItem_disabled__35DLO"};